/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { T, BG } from '../tema';
import { LOGO_SRC } from './Admin';
import { beregn_deadline_info } from './KlientOversigt';
import { HjaelpIkon, normaliser_sagstype } from './Ui';
import { toast } from '../utils';
// ── Moved from App.js: Infoskærm components (PR5) ────────────────────
// ═════════════════════════════════════════════════════════════════════
// EMPTYSTATE — stort visuelt tomskærm med handling (Task #7)
// ═════════════════════════════════════════════════════════════════════
// ─────────────────────────────────────────────────────────
// INFOSKÆRM — kontorskærm til ophæng og menupunkt
// ─────────────────────────────────────────────────────────
function InfoskærmVisning({ onTilbage, erKontorTilstand = false, skjulNotif = false }) {
 const [nu, setNu] = useState(new Date());
 const [is_sager, setIsSager] = useState([]);
 useEffect(() => {
 const t = setInterval(() => setNu(new Date()), 1000);
 return () => clearInterval(t);
 }, []);
 // Hent rigtige sager fra API
 useEffect(() => {
 const hent = () => {
 api("sager").then(data => {
 if (data && data.sager) {
 setIsSager(data.sager.map(s => ({
 id: String(s.id),
 navn: s.klient_navn || "Ukendt",
 nr: s.sagsnummer || `SV-${String(s.id).padStart(4,"0")}`,
 fase: s.fase || "—",
 deadline: s.næste_deadline || null,
 deadline_txt: beregn_deadline_info(s.næste_deadline).txt,
 deadline_titel: s.næste_deadline_titel || "",
 deadline_farve: beregn_deadline_info(s.næste_deadline).farve,
 risiko: s.risiko_score || 0,
 styrke_farve: (s.risiko_score||0) >= 70 ? "#69db7c" : (s.risiko_score||0) >= 40 ? "#ffd43b" : "#ff6b6b",
 status: s.status || "aktiv",
 primær: s.primær_navn || "—",
 })));
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 };
 hent();
 const interval = setInterval(hent, 60000);
 return () => clearInterval(interval);
 }, []);
 const DAGE = ["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"];
 const MDR = ["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december"];
 const hh = String(nu.getHours()).padStart(2,"0");
 const mm = String(nu.getMinutes()).padStart(2,"0");
 const ss = String(nu.getSeconds()).padStart(2,"0");
 const dato_tekst = DAGE[nu.getDay()] + " " + nu.getDate() + ". " + MDR[nu.getMonth()] + " " + nu.getFullYear();
 // Beregn rigtige data fra API
 const i_dag = new Date(); i_dag.setHours(0,0,0,0);
 const aktive_sager = is_sager.filter(s => s.status === "aktiv");
 const kritiske = aktive_sager.filter(s => {
 if (!s.deadline) return s.risiko > 75;
 const d = new Date(s.deadline); d.setHours(0,0,0,0);
 return d <= i_dag || s.risiko > 75;
 });
 const SAGER = [...aktive_sager].sort((a, b) => {
 const score_a = (!a.deadline ? 0 : new Date(a.deadline) <= i_dag ? 1000 : a.risiko);
 const score_b = (!b.deadline ? 0 : new Date(b.deadline) <= i_dag ? 1000 : b.risiko);
 return score_b - score_a;
 });
 const DEADLINES = aktive_sager
 .filter(s => s.deadline)
 .sort((a, b) => new Date(a.deadline) - new Date(b.deadline))
 .slice(0, 5)
 .map(s => {
 const d = new Date(s.deadline); d.setHours(0,0,0,0);
 const diff = Math.floor((d - i_dag) / 86400000);
 const farve = diff < 0 ? "#ff6b6b" : diff <= 5 ? "#ffd166" : "#06d6a0";
 return { titel: s.navn, deadline_titel: s.deadline_titel || "", sag: s.nr, tid: s.deadline_txt, farve, tid_farve: farve };
 });
 const MØDER = [];
 const HAENDELSER = [];
 const panel = {
 background: "rgba(255,255,255,0.06)", border: `1px solid rgba(255,255,255,0.14)`,
 borderRadius: 14, backdropFilter: "blur(20px)",
 WebkitBackdropFilter: "blur(20px)",
 };
 const kol_titel = {
 fontSize: 10, fontWeight: 500, color: T.dæmpet,
 letterSpacing: "0.12em", textTransform: "uppercase",
 marginBottom: 12, paddingBottom: 10,
 borderBottom: `1px solid rgba(255,255,255,0.06)`,
 };
 const separator = { borderTop: T.skillelinje, margin: "12px 0 10px" };
 return (
 <div style={{ minHeight:"100vh", background:BG, display:"flex", flexDirection:"column", padding: erKontorTilstand ? 20 : 0 }}>
 {/* Header — kun vist i app-tilstand */}
 {!erKontorTilstand && (
 <div style={{ padding:"14px 20px", borderBottom:`1px solid rgba(255,255,255,0.06)`, display:"flex", alignItems:"center", gap:14 }}> <button onClick={onTilbage} style={{ background:"none", border:"none", color:T.turkis, fontSize:13, display:"flex", alignItems:"center", gap:4 }}>← Tilbage</button> <div style={{ width:1, height:16, background:"rgba(255,255,255,0.08)" }} /> <img src={LOGO_SRC} alt="" style={{ height:28 }} /> <span style={{ color:T.dæmpet, fontSize:13 }}>Infoskærm</span> <div style={{ marginLeft:"auto", fontSize:12, color:T.dæmpet }}>
 Åbn i fuldskærm med F11 på den skærm der hænger på kontoret
 </div> </div>
 )}
 <div style={{ flex:1, padding: erKontorTilstand ? 0 : 20, display:"flex", flexDirection:"column", gap:14 }}>
 {/* Top: logo + ur */}
 <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", ...panel, padding:"16px 22px" }}> <div style={{ display:"flex", alignItems:"center", gap:14 }}> <img src={LOGO_SRC} alt="" style={{ height:48 }} /> <div> <div style={{ fontSize:22, fontWeight:300, color:T.creme }}>
 Skilsmisse<span style={{ color:T.turkis }}>Vejen</span> </div> <div style={{ fontFamily:"Clicker Script, cursive", fontSize:15, color:T.dæmpet }}>Du er ikke alene</div> </div> </div> <div style={{ textAlign:"right" }}> <div style={{ fontSize:42, fontWeight:300, color:T.creme, fontFamily:"DM Mono, monospace", letterSpacing:"-0.02em", lineHeight:1 }}>
 {hh}:{mm}:{ss}
 </div> <div style={{ fontSize:13, color:T.dæmpet, marginTop:4 }}>{dato_tekst}</div> </div> </div>
 {/* KPI strip */}
 <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(160px, 1fr))", gap:12 }}>
 {[
 { label:"Kritiske sager", tal:String(kritiske.length), sub:kritiske.length>0?"Kræver handling nu":"Ingen kritiske", farve:T.roed },
 { label:"Deadlines i dag", tal:String(DEADLINES.filter(d=>{ try { const dd=new Date(is_sager.find(s=>s.nr===d.sag?.split(" ")[0])?.deadline||""); dd.setHours(0,0,0,0); return dd<=i_dag; } catch { return false; }}).length), sub:DEADLINES.length>0?"Næste: "+DEADLINES[0].tid:"Ingen deadlines", farve:"#f59e0b" },
 { label:"Aktive sager", tal:String(aktive_sager.length), sub:"I systemet", farve:T.turkis },
 { label:"Møder i dag", tal:"0", sub:"Ingen møder registreret", farve:T.groen },
 ].map((k,i) => (
 <div key={i} style={{ ...panel, padding:"14px 18px" }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:6, letterSpacing:"0.06em" }}>{k.label}</div> <div style={{ fontSize:32, fontWeight:300, color:k.farve, lineHeight:1 }}>{k.tal}</div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:4 }}>{k.sub}</div> </div>
 ))}
 </div>
 {/* Hoved 3 kolonner */}
 <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:12, flex:1 }}>
 {/* Kolonne 1: Sager */}
 <div style={{ ...panel, padding:"16px 18px" }}> <div style={kol_titel}>Aktive sager — prioriteret</div>
 {SAGER.map((s,i) => (
 <div key={i} style={{ padding:"10px 0", borderBottom: i<SAGER.length-1 ? T.skillelinje : "none", display:"flex", gap:10 }}> <div title={s.risiko >= 70 ? "Stærk position" : s.risiko >= 40 ? "Moderat position" : "Svag position"} style={{ width:10, height:10, borderRadius:"50%", background:s.styrke_farve||"#475569", flexShrink:0, marginTop:4 }} /> <div style={{ flex:1 }}> <div style={{ fontSize:13, fontWeight:500, color:T.creme, lineHeight:1.3 }}>{s.navn}</div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:2 }}>{s.nr} · {s.fase || "—"}</div> <div style={{ fontSize:12, fontWeight:500, color:s.deadline_farve, marginTop:3 }}>{s.deadline_txt||"—"}</div> <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:6 }}> <div style={{ flex:1, height:3, borderRadius:2, background:"rgba(255,255,255,0.06)", overflow:"hidden" }}> <div style={{ height:"100%", width:`${Math.max(s.risiko, 3)}%`, background:s.styrke_farve||"#ff6b6b", borderRadius:2 }} /> </div> <span style={{ fontSize:12, color:s.styrke_farve||"#475569", fontWeight:600, flexShrink:0 }}>{s.risiko >= 70 ? "Stærk" : s.risiko >= 40 ? "Mod" : "Svag"}</span> </div> </div> </div>
 ))}
 </div>
 {/* Kolonne 2: Deadlines + møder */}
 <div style={{ ...panel, padding:"16px 18px" }}> <div style={kol_titel}>Deadlines denne uge</div>
 {DEADLINES.map((d,i) => (
 <div key={i} style={{ padding:"8px 0", borderBottom: i<DEADLINES.length-1 ? T.skillelinje : "none", display:"flex", alignItems:"center", gap:10 }}> <div style={{ width:9, height:9, borderRadius:"50%", background:d.farve, flexShrink:0 }} /> <div style={{ flex:1 }}> <div style={{ fontSize:12, fontWeight:500, color:T.creme }}>{d.titel}</div>
 {d.deadline_titel && <div style={{ fontSize:11, color:T.creme, marginTop:1 }}>{d.deadline_titel}</div>}
 <div style={{ fontSize:11, color:T.dæmpet }}>{d.sag}</div> </div> <div style={{ fontSize:12, fontWeight:500, color:d.tid_farve, flexShrink:0 }}>{d.tid}</div> </div>
 ))}
 <div style={separator} /> <div style={{ ...kol_titel, marginBottom:10 }}>Møder i dag</div>
 {MØDER.map((m,i) => (
 <div key={i} style={{ padding:"8px 0", borderBottom: i<MØDER.length-1 ? T.skillelinje : "none", display:"flex", gap:12, alignItems:"flex-start" }}> <div style={{ textAlign:"center", flexShrink:0, width:44, background:"rgba(255,255,255,0.04)", borderRadius:8, padding:"6px 4px" }}> <div style={{ fontSize:16, fontWeight:500, color:T.creme, lineHeight:1 }}>{m.hh}</div> <div style={{ fontSize:12, color:T.dæmpet }}>{m.mm}</div> </div> <div> <div style={{ fontSize:13, fontWeight:500, color:T.creme }}>{m.navn}</div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:2 }}>{m.info}</div> <div style={{ display:"inline-block", fontSize:12, padding:"2px 8px", borderRadius:6, marginTop:4, color:m.type_farve, background:`${m.type_farve}18`, border:`1px solid ${m.type_farve}33` }}>{m.type}</div> </div> </div>
 ))}
 </div>
 {/* Kolonne 3: Hændelser + system */}
 <div style={{ ...panel, padding:"16px 18px" }}> <div style={kol_titel}>Seneste hændelser</div>
 {HAENDELSER.map((h,i) => (
 <div key={i} style={{ padding:"8px 0", borderBottom: i<HAENDELSER.length-1 ? T.skillelinje : "none", display:"flex", gap:10 }}> <div style={{ fontSize:14, flexShrink:0, width:20, textAlign:"center" }}>{h.ikon}</div> <div style={{ flex:1 }}> <div style={{ fontSize:12, color:T.creme }}>{h.tekst}</div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:1 }}>{h.meta}</div> </div> <div style={{ fontSize:12, color:T.dæmpet, flexShrink:0 }}>{h.tid}</div> </div>
 ))}
 <div style={separator} /> <div style={{ ...kol_titel, marginBottom:10 }}>System og automation</div>
 {[
 ["Outlook-integration", "#f59e0b", "Afventer opsætning"],
 ["AI-journalisering", "#f59e0b", "Afventer opsætning"],
 ["Database", T.groen, "Kører"],
 ["Backup", T.groen, "I dag 03:00"],
 ["Telavox API", "#f59e0b", "Afventer opsætning"],
 ].map(([navn, farve, status], i, arr) => (
 <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom: i<arr.length-1 ? T.skillelinje : "none", fontSize:12 }}> <span style={{ color:T.dæmpet }}>{navn}</span> <span style={{ color:farve, fontWeight:500 }}>● {status}</span> </div>
 ))}
 </div> </div>
 {/* Bund */}
 <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:T.subtil }}> <span>SkilsmisseVejen Sagsportal · Kontorskærm</span> <span>● Live · opdateret {hh}:{mm}:{ss}</span> </div> </div> </div>
 );
}
// ── Moved from App.js: Infoskaerm V2, Danmark-kort (PR5) ─────────────
// ═════════════════════════════════════════════════════════════════════
// LEAFLET CDN-LOADER — én gang, delt mellem komponenter
// ═════════════════════════════════════════════════════════════════════
let _leaflet_loader_promise = null;
function hent_leaflet() {
 if (_leaflet_loader_promise) return _leaflet_loader_promise;
 if (typeof window !== "undefined" && window.L) {
 _leaflet_loader_promise = Promise.resolve(window.L);
 return _leaflet_loader_promise;
 }
 _leaflet_loader_promise = new Promise((resolve, reject) => {
 try {
 ["https://unpkg.com/leaflet@1.9.4/dist/leaflet.css",
 "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css",
 "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css"].forEach(href => {
 const link = document.createElement("link");
 link.rel = "stylesheet"; link.href = href;
 document.head.appendChild(link);
 });
 const s1 = document.createElement("script");
 s1.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
 s1.onload = () => {
 const s2 = document.createElement("script");
 s2.src = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js";
 s2.onload = () => resolve(window.L);
 s2.onerror = () => resolve(window.L); // cluster er optional
 document.head.appendChild(s2);
 };
 s1.onerror = () => reject(new Error("Kunne ikke indlæse Leaflet"));
 document.head.appendChild(s1);
 } catch (e) { reject(e); }
 });
 return _leaflet_loader_promise;
}
// ═════════════════════════════════════════════════════════════════════
// INFOSKAERM V2 — 4K kontorskærm (ikke-interaktiv)
// ═════════════════════════════════════════════════════════════════════
function InfoskaermV2({ onTilbage }) {
 const [data, setData] = useState(null);
 const [geo, setGeo] = useState([]);
 const [nu, setNu] = useState(new Date());
 const [, setRotation] = useState(0);
 const [geo_region_idx, setGeoRegionIdx] = useState(0);
 const [serverVersion, setServerVersion] = useState(null);
 // Hent data (dashboard + geo)
 const [postnumre, setPostnumre] = useState([]);
 // FEJL-010-fix: 403 på begge datakald blev tidligere tolket som "stadig
 // indlæser" (data forblev null → alle KPI'er viste 0 uden nogen fejlbesked).
 // Nu skelnes eksplicit mellem "intet svar endnu" og "adgang nægtet (403)",
 // så en tydelig besked kan vises i stedet for stille nul-tal.
 const [ingen_adgang, setIngenAdgang] = useState(false);
 const hent_alt = React.useCallback(async () => {
 try {
 const [d_res, g_res] = await Promise.all([
 fetch("/api/infoskaerm/dashboard", { credentials: "include" }),
 fetch("/api/infoskaerm/geo", { credentials: "include" }),
 ]);
 if (d_res.status === 403 || g_res.status === 403) { setIngenAdgang(true); return; }
 setIngenAdgang(false);
 const d = await d_res.json().catch(() => null);
 const g = await g_res.json().catch(() => null);
 if (d && !d.fejl) setData(d);
 if (g?.regioner) setGeo(g.regioner);
 if (g?.postnumre) setPostnumre(g.postnumre);
 } catch (e) { console.warn("[InfoskaermV2] hent fejl:", e?.message); }
 }, []);
 // Hent version fra /api/health
 useEffect(() => {
 fetch('/api/health')
 .then(r => r.json())
 .then(d => { if (d?.version) setServerVersion(d.version); })
 .catch(() => {});
 }, []);
 // Initial + 60s polling + SSE
 useEffect(() => {
 hent_alt();
 const iv = setInterval(hent_alt, 60000);
 // SSE
 let es = null;
 try {
 es = new EventSource("/api/events/stream", { withCredentials: true });
 es.addEventListener("sag_opdateret", hent_alt);
 es.addEventListener("ny_haendelse", hent_alt);
 } catch {}
 return () => { clearInterval(iv); if (es) es.close(); };
 }, [hent_alt]);
 // Klokke hvert sekund
 useEffect(() => {
 const iv = setInterval(() => setNu(new Date()), 1000);
 return () => clearInterval(iv);
 }, []);
 // Auto-rotation hvert 60s
 useEffect(() => {
 const iv = setInterval(() => setRotation(r => (r + 1) % 2), 60000);
 return () => clearInterval(iv);
 }, []);
 // Kort-region rotation hvert 45s
 useEffect(() => {
 if (geo.length === 0) return;
 const iv = setInterval(() => setGeoRegionIdx(i => (i + 1) % Math.max(1, geo.length)), 45000);
 return () => clearInterval(iv);
 }, [geo.length]);
 const kpi = data?.kpi || {};
 const kpi_bar = data?.kpi_bar || {};
 const kritiske = data?.kritiske || [];
 const uge = data?.uge || [];
 const belastning = data?.belastning || [];
 const aktivitet = data?.aktivitet || [];
 const alt_ok_kritiske = kritiske.length === 0;
 const dato_str = nu.toLocaleDateString("da-DK", { weekday:"long", day:"numeric", month:"long", year:"numeric" });
 const klok_str = nu.toLocaleTimeString("da-DK", { hour:"2-digit", minute:"2-digit", second:"2-digit" });
 return (
 <div style={{
 width:"100vw", minHeight:"100vh",
 background:"radial-gradient(ellipse at 20% 20%, rgba(35,34,190,0.18) 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, rgba(63,212,199,0.12) 0%, transparent 50%), #080c1e",
 color:"#e2e8f0",
 fontFamily:"'Inter',system-ui,sans-serif", padding:"clamp(20px, 2vw, 40px)",
 display:"flex", flexDirection:"column", gap:"clamp(16px, 1.5vw, 28px)",
 overflow:"hidden",
 }}>
 {/* Scanline overlay */}
 <div style={{ position:"fixed", inset:0, pointerEvents:"none", zIndex:0, background:"repeating-linear-gradient(0deg,transparent,transparent 3px,rgba(0,0,0,0.025) 3px,rgba(0,0,0,0.025) 4px)" }} />
 {/* Dot grid */}
 <div style={{ position:"fixed", inset:0, pointerEvents:"none", zIndex:0, backgroundImage:"radial-gradient(circle, rgba(255,255,255,0.02) 1px, transparent 1px)", backgroundSize:"32px 32px" }} />
 {/* HEADER */}
 <div style={{ position:"relative", zIndex:1, display:"flex", justifyContent:"space-between", alignItems:"center" }}> <div style={{ display:"flex", alignItems:"center", gap:20 }}> <div style={{ position:"relative" }}> <img src={LOGO_SRC} alt="SV" style={{ width:"clamp(48px, 4vw, 80px)", height:"clamp(48px, 4vw, 80px)", borderRadius:16, boxShadow:"0 0 32px rgba(63,212,199,0.25)" }} /> <div style={{ position:"absolute", inset:-4, borderRadius:20, border:"1px solid rgba(63,212,199,0.2)", pointerEvents:"none" }} /> </div> <div> <div className="sv-gradient-text" style={{ fontSize:"clamp(28px, 2.5vw, 48px)", fontWeight:700, letterSpacing:"-0.02em" }}>SkilsmisseVejen</div> <div style={{ fontSize:"clamp(14px, 1.2vw, 22px)", color:"#3fd4c7", textTransform:"capitalize" }}>{dato_str}</div> </div> </div> <div style={{ textAlign:"right" }}> <div style={{ fontSize:"clamp(48px, 5vw, 96px)", fontWeight:200, fontVariantNumeric:"tabular-nums", lineHeight:1, background:"linear-gradient(135deg, #ffffff, #3fd4c7)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text" }}>
 {klok_str.slice(0,5)}<span style={{ fontSize:"clamp(24px, 2vw, 40px)" }}>:{klok_str.slice(6)}</span> </div> <div style={{ fontSize:"clamp(12px, 0.9vw, 16px)", color:"#64748b", marginTop:6, display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8 }}> <span className="sv-pulse-dot" style={{ display:"inline-block", width:10, height:10, borderRadius:"50%", background:"#27ae60", boxShadow:"0 0 8px rgba(39,174,96,0.6)" }} />
 System online · opd. {data ? "nu" : "venter"}
 {serverVersion && (
 <span style={{
 marginLeft:8, fontSize:"clamp(13px, 1vw, 18px)", fontWeight:700,
 background:"rgba(201,168,76,0.15)",
 border:"1px solid rgba(201,168,76,0.45)",
 borderRadius:8, padding:"3px 12px",
 color:"#c9a84c",
 fontFamily:"monospace",
 letterSpacing:"0.04em",
 }}
 title="App-version"
 >
 v{serverVersion}
 </span>
 )}
 </div> </div> </div>
 {/* FEJL-010-fix: 403 (rolle mangler direktør-/systemadmin-/infoskærm-adgang)
     viste tidligere stille 0-tal i alle zoner uden nogen forklaring — nu vises
     en tydelig, tema-konsistent adgangsbesked i stedet, og de irrelevante
     0-KPI-zoner nedenfor skjules helt. Dette er tilsigtet backend-adfærd
     (infoskaerm.js: "Rolle: infoskaerm eller direktoer") — ikke en fejl der
     skal rettes i backend. */}
 {ingen_adgang ? (
 <div style={{ position:"relative", zIndex:1, flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", textAlign:"center", gap:14, padding:"40px 20px" }}>
 <div style={{ fontSize:"clamp(48px, 5vw, 88px)" }}>🔒</div>
 <div style={{ fontSize:"clamp(22px, 2vw, 36px)", fontWeight:700, color:"#e2e8f0" }}>Infoskærm kræver direktør-adgang</div>
 <div style={{ fontSize:"clamp(13px, 1vw, 18px)", color:"#94a3b8", maxWidth:560 }}>
 Din bruger har ikke rollen infoskærm, direktør eller systemadmin, som infoskærmens data kræver.
 Kontakt en administrator hvis du mener dette er en fejl.
 </div>
 </div>
 ) : (
 <>
 {/* GRID — 3 kolonner øverst, 2 i midten */}
 <div className="sv-infoskaerm-grid" style={{ display:"grid", gridTemplateColumns:"1.1fr 1.1fr 1.6fr", gap:"clamp(16px, 1.5vw, 28px)", flex:1, minHeight:0 }}>
 {/* KRITISKE DEADLINES (rød) */}
 <div style={{
 background: alt_ok_kritiske ? "rgba(39,174,96,0.08)" : "rgba(231,76,60,0.08)",
 border: `2px solid ${alt_ok_kritiske ? "rgba(39,174,96,0.3)" : "rgba(231,76,60,0.4)"}`,
 borderRadius:16, padding:"clamp(16px, 1.5vw, 28px)", display:"flex", flexDirection:"column", minHeight:0,
 }}> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", color: alt_ok_kritiske ? "#69db7c" : "#ff6b6b", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:700, marginBottom:16 }}>
 {alt_ok_kritiske ? " Alt under kontrol" : " Kritiske deadlines"}
 </div> <div style={{ flex:1, overflowY:"hidden" }}>
 {alt_ok_kritiske ? (
 <div style={{ textAlign:"center", padding:"40px 20px", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100%" }}> <div style={{ fontSize:"clamp(60px, 6vw, 120px)", marginBottom:20 }}></div> <div style={{ fontSize:"clamp(20px, 1.8vw, 32px)", fontWeight:600, color:"#69db7c" }}>Ingen kritiske deadlines</div> <div style={{ fontSize:"clamp(14px, 1vw, 18px)", color:"#cbd5e1", marginTop:10 }}>Teamet er på forkant</div> </div>
 ) : kritiske.slice(0, 6).map(k => {
 const dage = parseInt(k.dage_til);
 const overskredet = dage < 0;
 return (
 <div key={k.id} style={{
 display:"flex", alignItems:"center", gap:14, padding:"clamp(10px, 0.8vw, 18px)",
 borderBottom:"1px solid rgba(255,255,255,0.06)",
 animation: overskredet ? "infoskaerm-pulse 2s ease-in-out infinite" : "none",
 }}> <div style={{ width:8, height:"clamp(40px, 3vw, 60px)", borderRadius:4, background: overskredet ? "#ff6b6b" : "#ffd43b", flexShrink:0 }} /> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:"clamp(14px, 1.1vw, 22px)", fontWeight:600, color:"#fff" }}>
 {k.klient_pseudo || k.sagsnummer}
 <span style={{ fontSize:"clamp(11px, 0.8vw, 15px)", color:"#94a3b8", marginLeft:10, textTransform:"capitalize" }}>
 {k.sagstype}
 </span> </div> <div style={{ fontSize:"clamp(12px, 0.85vw, 16px)", color:"#94a3b8", marginTop:2 }}>
 {k.næste_deadline_titel || "Deadline"} · {k.sagsbehandler_init || "—"}
 </div> </div> <div style={{ textAlign:"right", flexShrink:0 }}> <div style={{ fontSize:"clamp(20px, 1.8vw, 32px)", fontWeight:800, color: overskredet ? "#ff6b6b" : "#ffd43b", lineHeight:1 }}>
 {overskredet ? `-${Math.abs(dage)}d` : dage === 0 ? "I DAG" : `${dage}d`}
 </div> </div> </div>
 );
 })}
 </div> </div>
 {/* DEADLINES DENNE UGE (gul) */}
 <div style={{
 background:"rgba(245,158,11,0.06)",
 border:"2px solid rgba(245,158,11,0.25)",
 borderRadius:16, padding:"clamp(16px, 1.5vw, 28px)", display:"flex", flexDirection:"column", minHeight:0,
 }}> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", color:"#ffd43b", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:700, marginBottom:16 }}>
 Deadlines denne uge
 </div> <div style={{ flex:1, overflowY:"hidden" }}>
 {uge.length === 0 ? (
 <div style={{ textAlign:"center", padding:40, color:"#64748b", fontSize:"clamp(14px, 1vw, 18px)" }}>Ingen deadlines denne uge</div>
 ) : uge.slice(0, 8).map(d => (
 <div key={d.id} style={{ display:"flex", gap:12, padding:"clamp(8px, 0.7vw, 14px)", borderBottom:"1px solid rgba(255,255,255,0.06)" }}> <div style={{ minWidth:"clamp(48px, 4vw, 80px)", textAlign:"center", padding:"clamp(4px, 0.3vw, 8px)", background:"rgba(255,255,255,0.04)", borderRadius:8 }}> <div style={{ fontSize:"clamp(10px, 0.7vw, 14px)", color:"#94a3b8", textTransform:"uppercase" }}>
 {new Date(d.næste_deadline).toLocaleDateString("da-DK", { weekday:"short" })}
 </div> <div style={{ fontSize:"clamp(18px, 1.6vw, 30px)", fontWeight:700, color:"#ffd43b" }}>
 {new Date(d.næste_deadline).getDate()}.
 </div> </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", fontWeight:600, color:"#fff" }}>{d.klient_pseudo || d.sagsnummer}</div> <div style={{ fontSize:"clamp(11px, 0.8vw, 15px)", color:"#94a3b8", marginTop:2 }}>
 {d.næste_deadline_titel || "Deadline"} · {d.sagsbehandler_init || "—"} · <span style={{ textTransform:"capitalize" }}>{d.sagstype}</span> </div> </div> </div>
 ))}
 </div> </div>
 {/* DANMARKSKORT (aggregat) */}
 <div style={{
 background:"rgba(63,212,199,0.04)",
 border:"2px solid rgba(63,212,199,0.2)",
 borderRadius:16, padding:"clamp(16px, 1.5vw, 28px)", display:"flex", flexDirection:"column", minHeight:0,
 }}> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", color:"#3fd4c7", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:700, marginBottom:16, display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:8 }}> <span> Sager pr. postnummer</span>
 {geo.length > 0 && (
 <span style={{ fontSize:"clamp(12px, 0.9vw, 16px)", color:"#cbd5e1", fontWeight:400, textTransform:"none", letterSpacing:"normal" }}>
 Flest: {geo[0].geo_region} ({geo[0].antal})
 </span>
 )}
 </div> <div style={{ flex:1, position:"relative", minHeight:0 }}> <InfoskaermKort postnumre={postnumre} regioner={geo} aktiv_region_idx={geo_region_idx} /> </div> </div>
 {/* SAGSBEHANDLER BELASTNING */}
 <div style={{
 gridColumn:"span 2", position:"relative", overflow:"hidden",
 background:"linear-gradient(135deg, rgba(10,14,46,0.9) 0%, rgba(15,20,52,0.85) 100%)",
 border:"1px solid rgba(255,255,255,0.1)",
 borderRadius:16, padding:"clamp(16px, 1.5vw, 28px)", minHeight:0,
 backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)",
 boxShadow:"0 8px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.07)",
 }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg,transparent,rgba(167,139,250,0.4),rgba(63,212,199,0.3),transparent)", pointerEvents:"none" }} /> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", color:"#cbd5e1", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:700, marginBottom:16 }}>
 Sagsbehandler-belastning
 </div> <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:"clamp(8px, 0.8vw, 16px)" }}>
 {belastning.slice(0, 6).map(b => {
 const antal = parseInt(b.aktive) || 0;
 const hoej = parseInt(b.hoej_risiko) || 0;
 const farve = antal >= 20 ? "#ff6b6b" : antal >= 12 ? "#ffd43b" : "#69db7c";
 const pct = Math.min(100, (antal / 25) * 100);
 return (
 <div key={b.id} style={{ padding:"clamp(10px, 0.8vw, 14px)", background:"rgba(255,255,255,0.02)", borderRadius:12, border:"1px solid rgba(255,255,255,0.05)" }}> <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}> <div style={{ width:"clamp(36px, 3vw, 56px)", height:"clamp(36px, 3vw, 56px)", borderRadius:"50%", background:`${farve}18`, border:`2px solid ${farve}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"clamp(12px, 1vw, 18px)", fontWeight:700, color:farve, boxShadow:`0 0 16px ${farve}33` }}>
 {b.initialer || "?"}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:"clamp(13px, 0.95vw, 18px)", fontWeight:600, color:"#fff" }}>{b.navn?.split(" ")[0] || "—"}</div> <div style={{ fontSize:"clamp(10px, 0.75vw, 13px)", color:"#94a3b8" }}>{hoej > 0 ? `${hoej} høj risiko` : "Ingen kritiske"}</div> </div> <div style={{ fontSize:"clamp(24px, 2.2vw, 40px)", fontWeight:700, color:farve, fontVariantNumeric:"tabular-nums", textShadow:`0 0 20px ${farve}55` }}>{antal}</div> </div> <div style={{ height:8, background:"rgba(255,255,255,0.05)", borderRadius:4, overflow:"hidden" }}> <div style={{ width:`${pct}%`, height:"100%", background:`linear-gradient(90deg, ${farve}88, ${farve})`, borderRadius:4, transition:"width 1.2s cubic-bezier(0.34,1.56,0.64,1)", boxShadow:`0 0 12px ${farve}66` }} /> </div> </div>
 );
 })}
 </div> </div>
 {/* SENESTE AKTIVITET */}
 <div style={{
 position:"relative", overflow:"hidden",
 background:"linear-gradient(135deg, rgba(10,14,46,0.9) 0%, rgba(14,20,52,0.85) 100%)",
 border:"1px solid rgba(255,255,255,0.09)",
 borderRadius:16, padding:"clamp(16px, 1.5vw, 28px)", display:"flex", flexDirection:"column", minHeight:0,
 backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)",
 boxShadow:"0 8px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.06)",
 }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg,transparent,rgba(63,212,199,0.3),transparent)", pointerEvents:"none" }} /> <div style={{ fontSize:"clamp(14px, 1vw, 20px)", color:"#cbd5e1", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:700, marginBottom:16 }}>
 Seneste aktivitet
 </div> <div style={{ flex:1, overflowY:"hidden" }}>
 {aktivitet.slice(0, 8).map((h, i) => {
 const tid = new Date(h.oprettet_dato);
 const minuts_siden = Math.floor((Date.now() - tid.getTime()) / 60000);
 return (
 <div key={h.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"clamp(6px, 0.5vw, 12px)", borderBottom: i < 7 ? "1px solid rgba(255,255,255,0.05)" : "none", animation: i === 0 ? "fadeUp 0.5s ease" : "none" }}> <div style={{ width:"clamp(28px, 2vw, 40px)", height:"clamp(28px, 2vw, 40px)", borderRadius:"50%", background:"rgba(63,212,199,0.15)", border:"1px solid rgba(63,212,199,0.3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"clamp(11px, 0.8vw, 14px)", fontWeight:600, color:"#3fd4c7", flexShrink:0 }}>
 {h.bruger_init || "?"}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:"clamp(12px, 0.9vw, 16px)", color:"#fff", textTransform:"capitalize" }}>
 {h.type}-aktivitet på <span style={{ color:"#3fd4c7", textTransform:"capitalize" }}>{h.sagstype}</span>-sag
 </div> <div style={{ fontSize:"clamp(10px, 0.7vw, 13px)", color:"#64748b" }}>
 {minuts_siden < 1 ? "lige nu" : minuts_siden < 60 ? `${minuts_siden} min siden` : tid.toLocaleTimeString("da-DK", { hour:"2-digit", minute:"2-digit" })}
 </div> </div> </div>
 );
 })}
 </div> </div> </div>
 {/* KPI-BAR */}
 <div className="sv-infoskaerm-kpi-bar" style={{
 position:"relative", overflow:"hidden",
 display:"grid", gridTemplateColumns:"repeat(5, 1fr)", gap:"clamp(12px, 1vw, 20px)",
 background:"linear-gradient(135deg, rgba(10,14,46,0.95) 0%, rgba(8,12,38,0.92) 100%)",
 border:"1px solid rgba(255,255,255,0.1)",
 borderRadius:16, padding:"clamp(14px, 1.2vw, 24px)",
 backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)",
 boxShadow:"0 8px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.07)",
 }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg,transparent,#3fd4c7,#a78bfa,#60a5fa,transparent)", pointerEvents:"none", zIndex:1 }} />
 {[
 { label:"Aktive sager", tal: kpi.aktive_sager, farve:"#3fd4c7" },
 { label:"Lukket denne måned", tal: kpi_bar.lukkede_maaned, farve:"#69db7c" },
 { label:"Gns. sagstid", tal: kpi_bar.gns_sagstid_dage, enhed:" dage", farve:"#60a5fa" },
 { label:"Fuldmagter udløb <30d", tal: kpi_bar.fuldmagt_udloeb_30d, farve:"#f59e0b" },
 { label:"Klienter i alt", tal: kpi_bar.total_klienter, farve:"#a78bfa" },
 ].map((k, i) => (
 <div key={i} style={{ textAlign:"center", padding:"8px 4px" }}> <CountUp tal={parseInt(k.tal) || 0} farve={k.farve} enhed={k.enhed || ""} /> <div style={{ fontSize:"clamp(11px, 0.8vw, 15px)", color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.12em", marginTop:6, fontWeight:600 }}>
 {k.label}
 </div> </div>
 ))}
 </div>
 </>
 )}
 </div>
 );
}
// Countup-animation (requestAnimationFrame, ~40 linjer)
function CountUp({ tal, farve, enhed }) {
 const [display, setDisplay] = useState(0);
 const prev = React.useRef(0);
 useEffect(() => {
 const start = prev.current;
 const diff = tal - start;
 const duration = 1200;
 const t0 = performance.now();
 let raf;
 const step = (t) => {
 const p = Math.min(1, (t - t0) / duration);
 const eased = 1 - Math.pow(1 - p, 3);
 setDisplay(Math.round(start + diff * eased));
 if (p < 1) raf = requestAnimationFrame(step);
 else prev.current = tal;
 };
 raf = requestAnimationFrame(step);
 return () => cancelAnimationFrame(raf);
 }, [tal]);
 return (
 <div style={{ fontSize:"clamp(36px, 3.5vw, 72px)", fontWeight:800, color:farve, lineHeight:1, fontVariantNumeric:"tabular-nums", textShadow:`0 0 24px ${farve}44` }}>
 {display}{enhed}
 </div>
 );
}
// Infoskaerm-kort — én nål pr. postnummer med sager (GDPR-safe: postnr ≠ individ)
function InfoskaermKort({ postnumre, regioner }) {
 const kort_ref = React.useRef(null);
 const map_instance = React.useRef(null);
 const layer_ref = React.useRef(null);
 const [map_klar, setMapKlar] = useState(false);
 const FARVER = { skilsmisse:"#ff6b6b", samvaer:"#60a5fa", samvær:"#60a5fa", bopael:"#69db7c", bopæl:"#69db7c", forældremyndighed:"#a78bfa", forældre:"#a78bfa", faderskab:"#f59e0b" };
 useEffect(() => {
 let mounted = true;
 hent_leaflet().then(L => {
 if (!mounted || !kort_ref.current || map_instance.current) return;
 try {
 const map = L.map(kort_ref.current, {
 center: [56.0, 10.5], zoom: 6, zoomControl: false,
 attributionControl: false, keyboard: false, dragging: false,
 scrollWheelZoom: false, doubleClickZoom: false, touchZoom: false,
 });
 L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}", {
 maxZoom: 12,
 }).addTo(map);
 map_instance.current = map;
 setMapKlar(true);
 } catch (e) { console.warn("[InfoskaermKort]", e?.message); }
 }).catch(e => console.warn("[Leaflet]", e?.message));
 return () => {
 mounted = false;
 if (map_instance.current) {
 try { map_instance.current.remove(); } catch {}
 map_instance.current = null;
 }
 setMapKlar(false);
 };
 }, []);
 // Tegn postnummer-nåle
 // eslint-disable-next-line react-hooks/exhaustive-deps
 useEffect(() => {
 const L = window.L;
 if (!L || !map_instance.current || !map_klar || !postnumre) return;
 if (layer_ref.current) {
 try { map_instance.current.removeLayer(layer_ref.current); } catch {}
 }
 const gruppe = L.layerGroup();
 for (const p of postnumre) {
 if (!p.lat || !p.lng) continue;
 const antal = parseInt(p.antal) || 0;
 const farve = FARVER[p.dominerende_sagstype] || "#3fd4c7";
 // Nål-størrelse afhænger af antal sager (18px for 1, op til 44px for 10+)
 const storrelse = Math.min(44, 18 + antal * 3);
 const pos = [parseFloat(p.lat), parseFloat(p.lng)];
 // Ydre pulse-ring (hvis flere sager i samme postnr)
 if (antal >= 2) {
 const pulse = L.circleMarker(pos, {
 radius: storrelse/2 + 6, color: farve, weight: 1,
 fillColor: farve, fillOpacity: 0.12, interactive: false,
 className: "infoskaerm-pulse-ring",
 });
 pulse.addTo(gruppe);
 }
 // Hovednål som div-ikon med antal
 const ikon = L.divIcon({
 html: `<div style="
 width:${storrelse}px;height:${storrelse}px;
 background:${farve};
 border:3px solid rgba(255,255,255,0.9);
 border-radius:50%;
 display:flex;align-items:center;justify-content:center;
 color:#fff;font-weight:800;
 font-size:${Math.max(11, storrelse * 0.4)}px;
 box-shadow:0 4px 12px rgba(0,0,0,0.4);
 font-family:'Inter',sans-serif;
 ">${antal}</div>`,
 className: "infoskaerm-postnr-naal",
 iconSize: [storrelse, storrelse],
 iconAnchor: [storrelse/2, storrelse/2],
 });
 const naal = L.marker(pos, { icon: ikon, interactive: false });
 // Permanent tooltip med postnr + by
 if (p.postnr && p.postnr !== 'ukendt') {
 naal.bindTooltip(`${p.postnr} ${p.postnr_navn || ""}`, {
 permanent: true, direction: "top", offset: [0, -storrelse/2 - 4],
 className: "infoskaerm-tooltip",
 });
 }
 naal.addTo(gruppe);
 }
 gruppe.addTo(map_instance.current);
 layer_ref.current = gruppe;
 // Auto-fit bounds hvis der er nåle
 try {
 if (postnumre.length > 0) {
 const bounds = L.latLngBounds(postnumre.filter(p => p.lat && p.lng).map(p => [parseFloat(p.lat), parseFloat(p.lng)]));
 if (bounds.isValid()) {
 map_instance.current.fitBounds(bounds, { padding: [40, 40], maxZoom: 9, animate: true, duration: 1 });
 }
 }
 } catch {}
 }, [postnumre, map_klar]);
 return (
 <div ref={kort_ref} style={{
 width:"100%", height:"100%", minHeight:200,
 background:"#0a0e2e", borderRadius:12, overflow:"hidden",
 }} />
 );
}
// ═════════════════════════════════════════════════════════════════════
// DANMARKSKORT — Admin-side (fuld interaktivitet)
// ═════════════════════════════════════════════════════════════════════
function DanmarkskortVisning({ onTilbage }) {
 const [klienter, setKlienter] = useState([]);
 const [status_filter, setStatusFilter] = useState("aktiv");
 const [sagstype_filter, setSagstypeFilter] = useState("");
 const [geo_status, setGeoStatus] = useState(null);
 const [loader, setLoader] = useState(true);
 const [map_klar, setMapKlar] = useState(false); // F: race-fix
 const [leaflet_fejl, setLeafletFejl] = useState(null);
 // V1.2.1: Hent sagstyper fra DB så kortet bruger admin-konfigurerede typer+farver
 const [db_sagstyper, setDbSagstyper] = useState([]);
 React.useEffect(() => {
 api("indstillinger/sag_typer").then(d => {
 if (d?.items) setDbSagstyper(d.items.filter(x => x.aktiv !== false));
 }).catch(() => {});
 }, []);
 const kort_ref = React.useRef(null);
 const map_instance = React.useRef(null);
 const layer_ref = React.useRef(null);
 const hent = React.useCallback(() => {
 setLoader(true);
 const params = new URLSearchParams();
 if (status_filter) params.set("status", status_filter);
 if (sagstype_filter) params.set("sagstype", sagstype_filter);
 api("geo/klienter?" + params.toString()).then(d => {
 if (d?.klienter) setKlienter(d.klienter);
 setLoader(false);
 }).catch(() => setLoader(false));
 api("geo/status").then(d => { if (d && !d.fejl) setGeoStatus(d); }).catch(() => {});
 }, [status_filter, sagstype_filter]);
 useEffect(() => { hent(); }, [hent]);
 // Init kort — med race-fix: setMapKlar(true) efter Leaflet er klar
 useEffect(() => {
 let mounted = true;
 hent_leaflet().then(L => {
 if (!mounted || !kort_ref.current || map_instance.current) return;
 try {
 const map = L.map(kort_ref.current, {
 center: [56.0, 10.5], zoom: 7,
 });
 L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
 maxZoom: 18,
 attribution: "Tiles © Esri · © Dawa.dk",
 }).addTo(map);
 map_instance.current = map;
 setMapKlar(true);
 } catch (e) {
 console.error("[Leaflet] init fejl:", e);
 setLeafletFejl("Kortet kunne ikke indlæses");
 }
 }).catch(e => {
 console.error("[Leaflet] load fejl:", e);
 setLeafletFejl("Kunne ikke indlæse kort-bibliotek");
 });
 return () => {
 mounted = false;
 if (map_instance.current) {
 try { map_instance.current.remove(); } catch {}
 map_instance.current = null;
 }
 setMapKlar(false);
 };
 }, []);
 // Opdater nåle — afhænger nu også af map_klar
 useEffect(() => {
 const L = window.L;
 if (!L || !map_instance.current || !map_klar) return;
 if (layer_ref.current) {
 try { map_instance.current.removeLayer(layer_ref.current); } catch {}
 }
 // Cluster-layer hvis markercluster er tilgængelig, ellers almindelig layerGroup
 const cluster = L.markerClusterGroup ? L.markerClusterGroup({
 iconCreateFunction: (cluster) => {
 const n = cluster.getChildCount();
 return L.divIcon({
 html: `<div style="background:#3fd4c7;color:#0c0f1a;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;font-weight:700;border:3px solid rgba(63,212,199,0.3)">${n}</div>`,
 className: "sv-cluster", iconSize: [40, 40],
 });
 },
 }) : L.layerGroup();
 // V1.2.1: Byg farve-map fra DB-sagstyper (normaliseret) med fallback til gamle hardcodede
 const FARVER = { skilsmisse:"#ff6b6b", samvær:"#60a5fa", bopæl:"#69db7c", forældremyndighed:"#a78bfa", faderskab:"#f59e0b" };
 const farve_map = {};
 db_sagstyper.forEach(t => {
 if (t.navn && t.farve) farve_map[normaliser_sagstype(t.navn)] = t.farve;
 });
 const hent_farve = (sagstype) => {
 const key = normaliser_sagstype(sagstype);
 return farve_map[key] || FARVER[sagstype] || FARVER[key] || "#94a3b8";
 };
 for (const k of klienter) {
 if (!k.geo_lat || !k.geo_lng) continue;
 const farve = hent_farve(k.sagstype);
 const aktiv = k.status === "aktiv";
 const icon = L.divIcon({
 html: `<div style="width:20px;height:20px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${aktiv ? farve : "transparent"};border:3px solid ${farve};box-shadow:0 2px 6px rgba(0,0,0,0.4)"></div>`,
 className: "sv-naal", iconSize: [24, 24], iconAnchor: [12, 24],
 });
 const m = L.marker([parseFloat(k.geo_lat), parseFloat(k.geo_lng)], { icon });
 m.bindPopup(`
 <div style="font-family:system-ui;min-width:200px"> <div style="font-weight:700;font-size:14px;color:#0c0f1a">${(k.klient_navn || "").replace(/</g,"&lt;")}</div> <div style="font-size:12px;color:#4a4a6a;margin-top:2px">${k.sagsnummer}</div> <div style="font-size:12px;color:#4a4a6a;margin-top:6px"> <span style="text-transform:capitalize">${k.sagstype}</span> · ${k.status}
 ${k.risiko_score ? `· risiko ${k.risiko_score}` : ""}
 </div> <div style="font-size:11px;color:#6a6a8a;margin-top:4px">${k.sagsbehandler_navn || "Ingen sagsbehandler"}</div> </div>
 `);
 cluster.addLayer(m);
 }
 cluster.addTo(map_instance.current);
 layer_ref.current = cluster;
 // Auto-zoom til alle nåle hvis der er nogen
 try {
 const bounds = cluster.getBounds ? cluster.getBounds() : null;
 if (bounds && bounds.isValid()) {
 map_instance.current.fitBounds(bounds, { padding: [50, 50], maxZoom: 10 });
 }
 } catch {}
 }, [klienter, map_klar, db_sagstyper]);
 return (
 <div style={{ padding:"clamp(16px, 2vw, 28px)", maxWidth:1400, margin:"0 auto" }}>
 {leaflet_fejl && (
 <div style={{ background:"rgba(231,76,60,0.1)", border:"1px solid rgba(231,76,60,0.3)", borderRadius:10, padding:"12px 16px", marginBottom:16, color:"#ff6b6b", fontSize:13 }}>
 Kortet kunne ikke indlæses: {leaflet_fejl}. Tjek internet eller genindlæs siden.
 </div>
 )}
 {!loader && klienter.length === 0 && !leaflet_fejl && (
 <div style={{ background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.3)", borderRadius:10, padding:"12px 16px", marginBottom:16, color:"#fbbf24", fontSize:13 }}>
 ℹ Ingen klienter matcher filteret. {geo_status?.pending > 0 ? `${geo_status.pending} klienter afventer geokoding.` : geo_status?.ikke_fundet > 0 ? `${geo_status.ikke_fundet} klienters adresse kunne ikke findes (ugyldig adresse).` : "Prøv at ændre status-filter eller opret en klient med adresse."}
 </div>
 )}
 <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12, marginBottom:20 }}> <div style={{ display:"flex", alignItems:"center", gap:12 }}>
 {onTilbage && <button onClick={onTilbage} style={{ background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"8px 14px", color:"#cbd5e1", cursor:"pointer", fontSize:13 }}>← Tilbage</button>}
 <h1 style={{ fontSize:24, fontWeight:300, color:"#e2e8f0", margin:0, display:"inline-flex", alignItems:"center", gap:8 }}> Geografisk overblik <HjaelpIkon tekst="Viser alle aktive klienter som pins på Danmarkskort. Klienter auto-geokodes via DAWA (Danmarks Adresser Webservice) ved oprettelse. Farve indikerer sagstype. Zoom/filtrer på status, region eller sagstype. Nyttigt til at spotte geografiske hotspots eller planlægge rejsedage." /></h1> </div> <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}> <select value={status_filter} onChange={e => setStatusFilter(e.target.value)} style={{ background:"rgba(255,255,255,0.06)", color:"#e2e8f0", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"8px 12px", fontSize:13 }}> <option value="aktiv">Aktive sager</option> <option value="lukket">Lukkede sager</option> <option value="alle">Alle</option> </select> <select value={sagstype_filter} onChange={e => setSagstypeFilter(e.target.value)} style={{ background:"rgba(255,255,255,0.06)", color:"#e2e8f0", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"8px 12px", fontSize:13 }}> <option value="">Alle sagstyper</option>
 {db_sagstyper.length > 0 ? (
 db_sagstyper.map(t => (
 <option key={t.navn} value={t.navn}>{t.navn}</option>
 ))
 ) : (
 // Fallback hvis DB endnu ikke er hentet
 <> <option value="skilsmisse">Skilsmisse</option> <option value="samvær">Samvær</option> <option value="bopæl">Bopæl</option> <option value="forældremyndighed">Forældremyndighed</option> <option value="faderskab">Faderskab</option> </>
 )}
 </select> </div> </div> <div style={{ display:"grid", gridTemplateColumns:"1fr 280px", gap:16, minHeight:600 }}> <div ref={kort_ref} style={{ background:"#0a0e2e", borderRadius:16, border:"1px solid rgba(255,255,255,0.08)", minHeight:600 }} /> <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:16, padding:20 }}> <div style={{ fontSize:12, color:"#94a3b8", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, marginBottom:12 }}>Status</div>
 {geo_status && (
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:14, color:"#69db7c" }}> {geo_status.fundet} geokodet</div> <div style={{ fontSize:14, color:"#ffd43b", marginTop:4 }}> {geo_status.pending} afventer</div> <div style={{ fontSize:14, color:"#ff6b6b", marginTop:4 }}> {geo_status.ikke_fundet} ikke fundet</div> </div>
 )}
 <div style={{ fontSize:12, color:"#94a3b8", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, marginBottom:12, marginTop:20 }}>Vist</div> <div style={{ fontSize:20, fontWeight:700, color:"#3fd4c7" }}>{loader ? "..." : klienter.length} klienter</div> <div style={{ marginTop:20, padding:14, background:"rgba(63,212,199,0.05)", border:"1px solid rgba(63,212,199,0.15)", borderRadius:10 }}> <div style={{ fontSize:12, color:"#3fd4c7", fontWeight:600, marginBottom:6 }}>Sagstype-farver</div> <div style={{ fontSize:12, color:"#cbd5e1", lineHeight:1.8 }}>
 {db_sagstyper.length > 0 ? (
 db_sagstyper.map(t => (
 <div key={t.navn}><span style={{ color: t.farve || "#94a3b8" }}>●</span> {t.navn}</div>
 ))
 ) : (
 <> <div><span style={{ color:"#ff6b6b" }}>●</span> Skilsmisse</div> <div><span style={{ color:"#60a5fa" }}>●</span> Samvær</div> <div><span style={{ color:"#69db7c" }}>●</span> Bopæl</div> <div><span style={{ color:"#a78bfa" }}>●</span> Forældremyndighed</div> <div><span style={{ color:"#f59e0b" }}>●</span> Faderskab</div> </>
 )}
 <div style={{ marginTop:8, fontSize:11, color:"#94a3b8" }}>Fyldt nål = aktiv, outline = lukket</div> </div> </div> </div> </div> </div>
 );
}
export { InfoskærmVisning, InfoskaermV2, DanmarkskortVisning };